import {MOBILE_PLANNING_ME_URL} from './mobile-planning.util';

/** Fallback avant chargement des permissions (mon planning). */
export const MOBILE_HOME_URL = MOBILE_PLANNING_ME_URL;
export const MOBILE_DASHBOARD_URL = '/pages/dashboard';

export interface MobileTab {
	id: 'dashboard' | 'service' | 'planning' | 'reservations' | 'tickets' | 'contracts' | 'menu';
	label: string;
	icon: string;
	route: string;
	matchPrefixes: string[];
	/** Ouvre la sidebar au lieu de naviguer (onglet Menu). */
	opensSidebar?: boolean;
}

export const MOBILE_MENU_TAB: MobileTab = {
	id: 'menu',
	label: 'Menu',
	icon: 'pi-bars',
	route: '',
	matchPrefixes: [],
	opensSidebar: true,
};

export const MOBILE_TABS: MobileTab[] = [
	{
		id: 'dashboard',
		label: 'Tableau de bord',
		icon: 'pi-chart-pie',
		route: MOBILE_DASHBOARD_URL,
		matchPrefixes: ['/pages/dashboard', '/pages/stats'],
	},
	{
		id: 'service',
		label: 'Service',
		icon: 'pi-check-square',
		route: '/pages/service',
		matchPrefixes: ['/pages/service', '/pages/suivi-pain', '/pages/caisse', '/pages/frigos'],
	},
	{
		id: 'planning',
		label: 'Planning',
		icon: 'pi-calendar-plus',
		route: MOBILE_PLANNING_ME_URL,
		matchPrefixes: ['/pages/planning'],
	},
	{
		id: 'reservations',
		label: 'Réservations',
		icon: 'pi-calendar',
		route: '/pages/reservations/list?view=today',
		matchPrefixes: ['/pages/reservations'],
	},
	{
		id: 'tickets',
		label: 'Tickets',
		icon: 'pi-headphones',
		route: '/pages/ticket',
		matchPrefixes: ['/pages/ticket'],
	},
];

